// MIGRATED FROM: api-client/contracts/hospital/
// MIGRATION DATE: 2024-08-24
// CHANGE TYPE: ENHANCED - Integrated api-client contracts with cheetah types
// BACKWARD COMPATIBLE: Yes - All existing types preserved
// RE-EXPORT API-CLIENT CONTRACTS
export type { SearchHospital } from 'api-client/contracts/search/SearchHospital'
export type { HospitalView, TimeTable, AssessmentStateType } from 'api-client/contracts/hospital'

export interface HospitalInList {
  id: number
  name: string
  rating: number
  ratingCount: number
  reviewCount: number
  pageCount: number
  profileImage: string
  photos: string[]
  updateTime: number
  mainImage: string
  supportingLangList: string[]
  assessmentState: 'CERTIFIED' | 'GROWTH' | 'EFFORT'
  sido: string
}

export interface GetHospitalsParams {
  start?: number
  sort?: string
  asc?: string
  country?: string
  length?: number
  assessmentState?: string
  treatmentCategoryTagIdList?: string
}

interface HospitalPhoto {
  id: number
  createTime: number
  updateTime: number
  url: string
  description: string
  seq: number
}

export enum AssessmentState {
  CERTIFIED = 'CERTIFIED', // 고객평가우수병원
  GROWTH = 'GROWTH', // 성장가능병원
  EFFORT = 'EFFORT', // 노력필요병원
}

export interface Hospital {
  id: number
  name: string
  introduction: string
  introImage: string
  district?: string
  rating: number
  ratingCount: number
  reviewCount: number
  sido: string
  country: string
  sigungu: string
  subwayCode: string
  subwayName?: string
  officeHours: string
  officeHoursJson: string
  officeHoursEtc: string
  eventCount: number
  address: string
  addressEn: string
  lat: number
  lng: number
  treatmentCategoryTagList: string[]
  ratingShow: true
  badgeCodeList: string[]
  title: string
  photos: HospitalPhoto[]
  profileImage: string
  mainImage: string
  canNormalConsultation: boolean
  authForeignConsultation: boolean
  supportingLangList: string[]
  addressInfos?: {
    accessRoute: string
    address: string
    addressDetail: string
    country: string
    lat: number
    lng: number
    sido: string
    sigungu: string
    sigunguCode: string
    subwayCodes: string[]
    zipCode: unknown
  }
  creditCardInfo?: {
    creditCards: string[]
    etc: string
  }
  medicalLoan?: {
    medicalLoan: boolean
    etc: string
  }
  assessmentState: AssessmentState
  recentConsultationMemberCount: number
  activePhoneConsultation: boolean
  activeChatConsultation: boolean
  activeGeneralConsultation: boolean
}

export enum SearchHospitalsSort {
  'CARD_LEVEL' = 'cardLevel',
  'PRIORITY' = 'priority',
  'REVIEW_COUNT' = 'reviewCount',
  'RATING' = 'rating',
  'RCMD' = 'rcmd',
}

export interface SearchHospitalsParams {
  q?: string
  sort?: SearchHospitalsSort
  start: number
  length: number
  districtCodeList?: string
}

export interface HospitalViewBadge {
  badgeCode: string
  badgeName: string
  badgeUrl: string
}
